/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { selectCounts } from 'mt-react-common/modules/main/reducers/static/states/counts/reducer';
import { getItemFromRefList } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import * as formatter from 'mt-react-common/utils/formatter';

import ContestPlacesList from './ContestPlacesList/index';
import ParticipateContestButton from '../../elements/ParticipateContestButton';

const ContestView = props => {
  if (!props.item) {
    return null;
  }
  return (
    <div id="contest_view">
      <div className="panel-group" role="tablist">
        <div className="panel panel-default panel_padding-adp panel_fullside-xs">
          <div className="panel-thumbnail">
            <div className="thumbnail_post">
              <div className="thumbnail-img m-b-0">
                <img
                  className="img-fill"
                  alt={''}
                  style={{
                    position: 'relative',
                    height: '200px',
                    backgroundImage: `url(${props.item.imageUrl})`
                  }}
                />
              </div>
            </div>
          </div>
          <div className="panel-heading" role="tab" id="awardNewHeading_new">
            <div className="media media_table media_padding-adp media_default media_lg">
              <div
                className="media-left media-middle media-icon hidden-sm hidden-xs"
                style={{
                  width: '30px',
                  fontSize: '24px',
                  textAlign: 'center',
                  whiteSpace: 'nowrap'
                }}
              >
                <i className="fa fa-fw fa-trophy text-warning" />
              </div>
              <div className="media-body media-middle full-width">
                <div className="media-content">
                  <div className="media-info">
                    <h1
                      className="media-info-name text-overflow_2lines_all"
                      title={props.item.title}
                    >
                      {props.item.title}{' '}
                    </h1>
                    <div className="media-info-desc text-overflow">
                      <span className="text-warning">
                        <i className="fa fa-trophy hidden-md hidden-lg" />{' '}
                        {props.item.descStatus}{' '}
                      </span>
                      · {formatter.dateFormat4(props.item.dateFrom)} →{' '}
                      {formatter.dateFormat4(props.item.dateTo)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24 col-sm-24">
          <ContestPlacesList
            contestsPlaces={props.item.contestsPlaces}
            contestMeState={props.item.contestMeState}
            contestsDescItemType={props.contestsDescItemType}
          />
          <div className="panel panel-default panel_padding-adp panel_fullside-xs">
            <div className="panel-heading">
              <h2 className="display-name">Описание</h2>
            </div>
            <div className="panel-body">
              <div className="media media_table media_padding-adp media_default media_md">
                <div className="media-left media-icon">
                  <i className="fa fa-info-circle fa-fw text-muted" />
                </div>
                <div className="media-body">
                  <div className="media-content">
                    <div
                      className="media-content-data typography p-0"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: props.item.descHtml }}
                    />
                  </div>
                </div>
              </div>
              <div className="media media_table media_padding-adp media_default media_md">
                <div className="media-left media-icon">
                  <i className="fa fa-trophy fa-fw text-muted" />
                </div>
                <div className="media-body media-middle">
                  <div className="media-content">
                    <div
                      className="media-content-data typography p-0"
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: props.item.descPrizesHtml
                      }}
                    />
                  </div>
                </div>
              </div>
              {props.item.contestMeState === null ? (
                <React.Fragment>
                  <hr />
                  <ParticipateContestButton contestId={props.item.id} />
                </React.Fragment>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ContestView.defaultProps = {
  contestMeState: null
};

ContestView.propTypes = {
  // CONNECT STATES
  contestsDescItemType: PropTypes.shape({
    valueDesc: PropTypes.string.isRequired
  }).isRequired,
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    descStatus: PropTypes.string.isRequired,
    dateFrom: PropTypes.string.isRequired,
    dateTo: PropTypes.string.isRequired,
    descHtml: PropTypes.string.isRequired,
    descPrizesHtml: PropTypes.string.isRequired,
    contestsPlaces: PropTypes.arrayOf(PropTypes.shape).isRequired,
    contestMeState: PropTypes.shape({})
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  counts: selectCounts(state),
  contestsDescItemType: getItemFromRefList(state, 'contestsDescItemTypes').find(
    i => i.type === props.item.type
  )
});

export default connect(mapStateToProps)(ContestView);



// WEBPACK FOOTER //
// ./src/components/Contest/layouts/ContestView/ContestView.js